import React from 'react';
import LiquidEther from './components/LiquidEther';
import TextType from './components/TextType';
import './components/LiquidEther.css';
import './Overlay.css';

function App() {
  return (
    <div style={{ position: 'relative', width: '100vw', height: '100vh', overflow: 'hidden' }}>
      <LiquidEther
        colors={['#5227FF', '#FF9FFC', '#B19EEF']}
        mouseForce={20}
        cursorSize={100}
        isViscous={false}
        iterationsPoisson={32}
        iterationsViscous={32}
        resolution={0.5}
        autoDemo={true}
      />

      <div className="overlay">
        <h1 className="title">
          <TextType
            text="REVERSITE"
            typingSpeed={120}
            deletingSpeed={60}
            pauseDuration={3000}
            loop={true}
            showCursor={true}
          />
        </h1>

        <p className="subtitle">
          Сайт временно скрыт, но мы всегда на связи в Telegram
        </p>

        <a
          href="https://t.me/demonima"
          target="_blank"
          rel="noopener noreferrer"
          className="tg-button"
        >
          Написать в Telegram
        </a>
      </div>
    </div>
  );
}

export default App;